import { ReactElement, ReactNode } from 'react';
import { cn } from '../utils/cn';

interface FormCardProps {
  children: ReactNode;
  className?: string;
}

export default function FormCard({ children, className }: FormCardProps): ReactElement {
  return (
    <div
      className={cn(
        'cr-mb-4 cr-flex cr-flex-col cr-rounded-lg cr-bg-white cr-p-2 cr-text-center cr-shadow-md md:cr-w-[640px] md:cr-text-left',
        className
      )}
    >
      {children}
    </div>
  );
}
